import Routes from '../helpers/Routes';
import { INotificationListParams } from '../models/NotificationsModel';
import httpClient from './httpClient';

class NotificationController {
  basePath: string;
  constructor() {
    this.basePath = Routes.notifications.basePath;
  }

  getNotificationsCount = async () =>
    httpClient.get(
      `${this.basePath}${Routes.notifications.notification}${Routes.notifications.count}`
    );

  getNotificationsList = async (params: INotificationListParams) =>
    httpClient.post(`${this.basePath}${Routes.notifications.notifications}`, {
      pagingModel: params,
    });

  getNotification = async (notificationId: string) =>
    httpClient.get(
      `${this.basePath}${Routes.notifications.notification}/${notificationId}`
    );

  markAsRead = async () =>
    httpClient.get(
      `${this.basePath}${Routes.notifications.notification}${Routes.notifications.markAsRead}`
    );

  deleteNotification = async (notificationId: string) =>
    httpClient.delete(
      `${this.basePath}${Routes.notifications.notification}/${notificationId}`
    );

  deleteAllNotifications = async () =>
    httpClient.delete(`${this.basePath}${Routes.notifications.notifications}`);

  deleteSelectedNotifications = async (notificationIds: Array<string>) =>
    httpClient.post(
      `${this.basePath}${Routes.notifications.notifications}${Routes.general.delete}`,
      {
        notificationIds,
      }
    );

  markAsReadSelected = async (notificationIds: Array<string>) =>
    httpClient.post(
      `${this.basePath}${Routes.notifications.notification}${Routes.notifications.markAsRead}`,
      {
        notificationIds,
      }
    );
}

export default new NotificationController();
